import React from "react";
import intl from "react-intl-universal";

import { NoData } from "components/NoData";

export const SelectTeamNotify = () => {
  return <NoData label={intl.get("TEAMS_MANAGE_NO_TEAMS")} />;
};
